<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4.002 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8.036a3 3 0 0 1-3 3h-1.626a1 1 0 0 0-.638.23l-2.74 2.27-2.704-2.267a1 1 0 0 0-.642-.233h-1.65a3 3 0 0 1-3-3z"
      stroke="currentColor"
    stroke-linejoin="round"
    stroke-width="2"
    />
    <path
      d="M12.571 7.571a.571.571 0 1 0-1.142 0c0 1.121-.249 1.798-.655 2.204-.405.405-1.082.654-2.203.654a.571.571 0 1 0 0 1.142c1.121 0 1.798.249 2.204.655.405.405.654 1.082.654 2.203a.571.571 0 1 0 1.142 0c0-1.121.249-1.798.655-2.203.405-.406 1.082-.655 2.203-.655a.571.571 0 1 0 0-1.142c-1.121 0-1.798-.249-2.203-.654-.406-.406-.655-1.083-.655-2.204"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
